import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<p>Керамическая пивная кружка объемом 500мл в двух цветовых вариантах.</p><p>Область печати: 20см от ручки до ручки.<br/>Зона печати по вертикали – 9см, по 0.5см отступ сверху и снизу.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
